export default {
    "dynamicFormsRename_title": "Renombrar formulario: ",
    "dynamicFormsRename_success": "Exito",
    "dynamicFormsRename_successMessage": "Formulario renombrado"
}